var _path, _path2, _path3, _path4, _polygon, _polygon2, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLighting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#686868",
    d: "M30.2,8.1C27.3,5.9,23.6,5,20,5.7c-4.8,0.9-8.6,4.7-9.5,9.5c-0.6,3.8,0.9,7.7,3.9,10.2 c1.3,1.2,2.1,2.9,2.2,4.7h0.1v5.8c0,0.3,0.3,0.6,0.6,0.6c0,0,0,0,0,0h0.6c0.1,1.6,1.5,2.9,3.1,3h2.8c1.7-0.1,3-1.4,3.2-3h0.6 c0.3,0,0.6-0.3,0.6-0.6l0,0v-5.8l0,0c0-1.9,0.9-3.7,2.4-4.8c2.5-2.1,3.9-5.2,3.9-8.4C34.5,13.4,32.9,10.1,30.2,8.1z M23.8,38.4H21 c-1-0.1-1.8-0.8-1.9-1.8h6.6C25.7,37.5,24.8,38.3,23.8,38.4z M27,35.4H18v-4.8H27V35.4z M21.5,20.4h1.9v9h-1.9V20.4z M20.3,19.2h-1 c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9c0.5,0,0.9,0.4,1,0.9V19.2z M24.6,18.2c0-0.5,0.4-0.9,0.9-0.9c0,0,0.1,0,0.1,0 c0.5,0,0.9,0.4,0.9,0.9c0,0.5-0.4,0.9-0.9,0.9l0,0h-1V18.2z M27,29.4h-2.4v-9h1c1.2,0,2.1-0.9,2.1-2.1c0-1.2-0.9-2.1-2.1-2.1 c-1.2,0-2.1,0.9-2.2,2.1v0.9h-1.9v-0.9c0-1.2-1-2.2-2.2-2.2c-1.2,0-2.2,1-2.2,2.2l0,0c0.1,1.2,1,2.1,2.2,2.1h1v9h-2.5 c-0.3-1.9-1.2-3.6-2.6-4.9c-2.7-2.2-4-5.7-3.4-9.1c0.7-4.3,4.2-7.8,8.5-8.5c3.2-0.6,6.4,0.1,9,2.1c4.4,3.4,5.2,9.7,1.8,14 c-0.4,0.5-0.9,1-1.4,1.5C28.2,25.7,27.3,27.4,27,29.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBE900",
    d: "M19.3,17.4c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9h1v-0.9C20.3,17.7,19.9,17.3,19.3,17.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBE900",
    d: "M25.6,19.2c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9l0,0c-0.5-0.1-0.9,0.3-1,0.8c0,0,0,0.1,0,0.1v0.9 L25.6,19.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M21,38.4h2.8c1,0,1.8-0.8,1.9-1.8h-6.6C19.3,37.5,20.1,38.3,21,38.4z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FBE900",
    points: "23.5,20.4 21.5,20.4 21.5,29.4 23.5,29.4 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "24.2,30.6 23.8,30.6 18,30.6 18,35.3 18.5,35.3 18.5,35.3 18.5,35.3 26.5,35.3 26.5,35.3 26.5,35.3  27,35.3 27,30.6 "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBE900",
    d: "M29.8,24.5c4.2-3.6,4.7-9.9,1.1-14.1c-0.4-0.5-0.9-1-1.5-1.4c-2.6-2-5.8-2.7-9-2.1c-4.3,0.7-7.8,4.2-8.5,8.5 c-0.6,3.4,0.7,6.9,3.4,9.1c1.4,1.3,2.3,3,2.6,4.9h2.5v-9h-1c-1.2,0-2.1-0.9-2.2-2.1c0-1.2,1-2.2,2.2-2.2c1.2,0,2.2,1,2.2,2.2v0.9 h1.9v-0.9c0.1-1.2,1-2.1,2.2-2.1c1.2,0,2.1,0.9,2.1,2.1s-0.9,2.1-2.1,2.1h-1v9H27C27.3,27.4,28.2,25.7,29.8,24.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLighting);
export default __webpack_public_path__ + "static/media/lighting.205e074bd9afa89762804ba7f853407e.svg";
export { ForwardRef as ReactComponent };